import { useEffect, useState } from 'react';
import { useLocale } from '../special/LanguageProvider';
import { useAuthContext } from '../special/oAuthProvider';

export default () => {
  const [products, setProducts] = useState([]);
  const { lang, setLanguage } = useLocale();
  const { logOut } = useAuthContext();

  useEffect(
    () => {
      if (lang === 'is') {
        setProducts([
          {
            label: 'English',
            iconCls: 'icon-earth',
            onClick: () => setLanguage('en')
          },
          {
            label: 'Útskrá',
            iconCls: 'icon-lock',
            onClick: () => logOut()
          }
        ]);
      } else {
        setProducts([
          {
            label: 'Íslenska',
            iconCls: 'icon-earth',
            onClick: () => setLanguage('is')
          },
          {
            label: 'Log out',
            iconCls: 'icon-lock',
            onClick: () => logOut()
          }
        ]);
      }
    },
    [lang]
  );

  return products;
};
